import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Box, IconButton, Typography, Toolbar } from '@material-ui/core';
import { experimentalStyled } from '@mui/material/styles';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './AccountPopover';
import ContentSearch from './ContentSearch';
import LogoBlanc from '../LogoBlanc';
import NotificationsPopover from './NotificationsPopover';
import TaskNotificationsPopover from './TaskNotificationsPopover';
import useSettings from "../../hooks/useSettings";
import Logo from '../Logo';

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: 'white',
    boxShadow: 'none',
    color: theme.palette.primary.contrastText,
    borderBottom: `1px solid ${theme.palette.divider}`
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none'
  }),
  zIndex: theme.zIndex.drawer + 100
}));

const DashboardNavbar = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  const settings = useSettings();
  const { hostname } = window.location;
  const tenant = hostname.split('.')[0].toUpperCase();

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <IconButton
          color="primary"
          onClick={onSidebarMobileOpen}
          sx={{
            display: {
              lg: 'none'
            }
          }}
        >
          <MenuIcon fontSize="small" />
        </IconButton>
        <RouterLink to="/dashboard">
        {settings.settings.theme === "LIGHT" && (
              <Logo
                sx={{
                  height: 60,
                  width: 120,
                }}
              />
            )}
            {settings.settings.theme === "DARK" && (
              <LogoBlanc
                sx={{
                  height: 60,
                  width: 120,
                }}
              />
            )}
        </RouterLink>
       <Typography
       color="textPrimary"
       variant="subtitle2"
       sx={{ mt: 1 }}>
        {tenant}
       </Typography>

        <Box
          sx={{
            flexGrow: 1,
            ml: 2
          }}
        />
        <Box sx={{ ml: 1 }}>
          <ContentSearch />
        </Box>
        <Box sx={{ ml: 1, mr: 2  }}>
          <NotificationsPopover />
        </Box>
        <Box sx={{ ml: 1 }}>
          <TaskNotificationsPopover />
        </Box>
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default DashboardNavbar;
